<script>
import V1LanguageTab from "./components/V1LanguageTab.vue";
import V1AcademicTab from "./components/V1AcademicTab.vue";
export default {
    components: {
        V1LanguageTab,
        V1AcademicTab,
    },
    data() {
        return {};
    },
    computed: {
        ag() {
            return this.$parent.ag;
        },
        wid() {
            return this.$parent.wid;
        },
        Setting() {
            return this.$parent.Settings;
        },
        Translation() {
            return this.$parent.Translation;
        },
    },
};
</script>
<template>
    <!-- Vertical Program Search -->
    <div :class="{'grid-container': this.Setting.SearchMode == 0}">
        <V1LanguageTab v-if="this.Setting.SearchMode === 0 || this.Setting.SearchMode == 1" />
        <V1AcademicTab v-if="this.Setting.SearchMode === 0 || this.Setting.SearchMode == 2" />
    </div>
</template>
